import { useMemo } from "react";

import { useNotify } from "react-admin";

import { useQuery } from "@tanstack/react-query";

import { getQuotes } from "utils/api";

export const useQuotes = (customerFileId: number, isNewQuoteFormOpen: boolean) => {
  const notify = useNotify();

  const {
    data: quotes = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["quotes", customerFileId],
    queryFn: async () => {
      const response = await getQuotes(customerFileId);
      return response.data;
    },
    enabled: !isNewQuoteFormOpen,
    onError: (error: any) => {
      notify(`Error fetching quotes: ${(error && error.message) || "Unknown error"}`, "error");
    },
  });

  const lastQuote = useMemo(() => quotes[quotes.length - 1], [quotes]);

  return {
    quotes,
    lastQuote,
    isLoading,
    refetch,
  };
};
